<template>
  <div class="contain">
    <!-- <div class="top">
      <ul class="deslist justaround">
        <li class="desitem padone margin8">
          <p>
            解锁<span>进阶搜索</span>、<br /><span>附近搜索</span
            >，<span>无限次</span>使用
          </p>
        </li>
        <li class="desitem padtwo">
          <p>
            <span>畅读</span>传世文献、出土文献、海外文献，
            <span>670种</span>，约<span>2亿字</span>
          </p>
        </li>
      </ul>
      <ul class="deslist">
        <li class="desitem padfour">
          <p>
            <span>笔记</span>随心写随时导出,<br />
            <span>收藏</span>不受限,<br /><span>多维学术统计</span>数据<br />
            一键导出。
          </p>
        </li>
        <li class="desitem padfive">
          <p>
            汇览儒学研究最新成果，<br />
            《儒藏》海量信息，<br />
            数字化<span>忠实再现</span>， <br />其<span>超大图表</span>，<br />
            全幅展现学术源流、沿革始末
          </p>
        </li>
        <li class="desitem padsix">
          <p>
            <span>三分屏</span>设计自由拖拽，<br />横竖排模式自由切换，<br />
            颜色、字号自由定义，<br />打造专属<span>个性阅读体验</span>
          </p>
        </li>
      </ul>
    </div> -->

    <div class="middle">
      <div class="top"><img src="/static/wenku/top1.png" alt="" /></div>
      <ul class="kalist">
        <li
          v-for="proitem in productList"
          :key="proitem.rankId"
          :class="
            proitem.rankId == activeProduct.rankId ? 'kaitem zhezhao' : 'kaitem'
          "
          @click="changechoose(proitem)"
        >
          <!-- opacity: proitem.rankId == activeProduct.rankId ? 0.5 : 1, -->
          <img :src="baseUrl + proitem.rankIcon" alt="" />
        </li>
        <!-- <li class="kaitem zhezhao">
          <img src="/static/products/1690429536312.jpg" alt="" />
        </li> -->
        <!-- :style="{
            'background-color':
              proitem.rankId == activeProduct.rankId ? '#ebeef5' : '',
          }" -->

        <!-- <li
          v-for="proitem in productList"
          :key="proitem.rankId"
          class="kaitem"
          @click="
            changechoose(proitem.rankId, proitem.price, proitem.salePrice)
          "
          :style="{
            'background-color':
              proitem.rankId == activeProduct.rankId ? '#ebeef5' : '',
          }"
        >
          <span class="katitle">{{
            proitem.validityMonth == 1
              ? "月"
              : proitem.validityMonth == 3
              ? "季"
              : proitem.validityMonth == 12
              ? "年"
              : ""
          }}</span>
          <p class="kayue" v-if="proitem.validityMonth == 1">
            <span class="kacontent marginTop"
              >{{ proitem.salePrice }}元/月 </span
            ><span class="kades ver">收书全面<br />突破传统</span>
          </p>
          <p class="kastart" v-if="proitem.validityMonth == 3">
            <span class="kades">版本精善<br />校勘确当</span><br /><span
              class="kacontent"
              >{{ proitem.salePrice }}元/季
            </span>
          </p>
          <p class="kaend" v-if="proitem.validityMonth == 12">
            <span class="kacontent">{{ proitem.salePrice }}/年</span>
            <br />
            <span class="kades textright">编研并举<br />传承创新</span>
          </p>
        </li> -->

        <!-- <li
          class="kaitem"
          :style="{ 'background-color': activeKa == 1 ? '#ebeef5' : '' }"
        >
          <span class="katitle">月</span>
          <p class="kayue">
            <span class="kacontent marginTop">300元/月 </span
            ><span class="kades ver">收书全面<br />突破传统</span>
          </p>
        </li>
        <li
          class="kaitem"
          :style="{ 'background-color': activeKa == 2 ? '#ebeef5' : '' }"
        >
          <span class="katitle">季</span>
          <p class="kastart">
            <span class="kades">版本精善<br />校勘确当</span><br /><span
              class="kacontent"
              >500元/季
            </span>
          </p>
        </li>
        <li
          class="kaitem"
          :style="{ 'background-color': activeKa == 3 ? '#ebeef5' : '' }"
        >
          <span class="katitle">年</span>
          <p class="kaend">
            <span class="kacontent">1000元/年</span>
            <br />
            <span class="kades textright">编研并举<br />传承创新</span>
          </p>
        </li> -->
      </ul>
      <div class="realpay">
        <p>
          應付金額：<span style="color: #9b0000"
            >{{ activeProduct.salePrice }}元</span
          >
          <!-- <span
            class="applyInvoice"
            @click="daoqiDialogVisible = true"
            >申请发票</span
          > -->
        </p>
      </div>
      <div class="selbutton">
        <button class="openbutton" @click="getImgCode">確認購買</button>
      </div>
    </div>
    <div class="question">
      <div class="quescontain">
        <div class="queshead"><p>常見問題</p></div>
        <ul class="queslist">
          <li class="quesitem">
            <p class="containhead">
              1、三種會員卡有什麽不同？<img
                :class="questions['one'] ? 'openicon rotate' : 'openicon'"
                src="/static/products/sanjiao1.png"
                @click="changeShow('one')"
              />
            </p>
            <p
              class="anwser buluback zindexone"
              :style="{ display: questions['one'] ? 'block' : 'none' }"
            >
              在用户中心頁面，點擊“充值中心”購買會員卡升級平臺訪問權限。會員卡分為月卡（39元）、季卡（99元）、年卡（299元）。完成支付手續，會員卡即時生效。月卡有效期為1個月。季卡有效期為3個月。年卡有效期為12個月。購買任意會員卡，生效后均自動開通平臺最高訪問權限。
              用户中心頁面有會員卡到期時間提醒。
              <!-- 個人用户綁定集團賬號後，將默認獲得集團機構和個人有效期限的疊加權限。 -->
            </p>
          </li>
          <li class="quesitem">
            <p class="containhead">
              2、集團機構如何購買會員卡？<img
                :class="questions['two'] ? 'openicon rotate' : 'openicon'"
                src="/static/products/sanjiao1.png"
                @click="changeShow('two')"
              />
            </p>
            <p
              class="anwser buluback zindexone"
              :style="{ display: questions['two'] ? 'block' : 'none' }"
            >
              集團機構目前暫不支持綫上購買會員卡。集團機構如需試用或購買，<a
                class="fontcolor"
                href="/static/products/数字大仓文库试用申请表.docx"
                >請下載《試用申請表》</a
              >，填寫完成后發送至anyifei@pup.cn。更多具體事宜，可致電010-62752486進行咨詢。
            </p>
          </li>
          <li class="quesitem fffback">
            <p class="containhead">
              3、支付遇到問題？<img
                :class="questions['three'] ? 'openicon rotate' : 'openicon'"
                src="/static/products/sanjiao2.png"
                @click="changeShow('three')"
              />
            </p>
            <p
              class="anwser fffback zindextwo"
              :style="{
                display: questions['three'] ? 'block' : 'none',
              }"
            >
              使用過程中遇到任何產品技術問題，請致電010-62752035，郵箱：digital2@pup.cn。
            </p>
          </li>
          <li class="quesitem fffback">
            <p class="containhead">
              4、如何申請發票？<img
                :class="questions['four'] ? 'openicon rotate' : 'openicon'"
                src="/static/products/sanjiao2.png"
                @click="changeShow('four')"
              />
            </p>
            <p
              class="anwser fffback zindextwo"
              :style="{
                display: questions['four'] ? 'block' : 'none',
              }"
            >
              本系統默認不開發票。如果您需要開具發票，本系統只能開具“服務費”，並按照訂單實際支付金額實開。請您完成支付後，點擊“<span
                class="fontcolor"
                @click="openinvoicedialog()"
                >申請發票</span
              >”按鈕，填寫詳細的發票抬頭。
            </p>
          </li>
        </ul>
      </div>
    </div>
    <payPage
      v-if="centerDialogVisible"
      :centerDialogVisible="centerDialogVisible"
      :orderId="orderId"
      @changeVisible="doChangeVisible"
      :kaimg="activeProduct.rankIcon"
    ></payPage>
    <invoice
      :key="timer"
      v-show="daoqiDialogVisible"
      :daoqiDialogVisible="daoqiDialogVisible"
      @changeVisible="changeVisible"
    ></invoice>
  </div>
</template>

<script>
import payPage from "../../components/payPage.vue"
import invoice from "./invoice"
import eventBus from "@/utils/eventBus.js"
import {
  getRankList,
  getOrder,
  orderDetail,
} from "@/api/api"
export default {
  name: "Products",
  components: { payPage, invoice },
  data () {
    return {
      daoqiDialogVisible: false,//开发票dialog是否展示
      activeNames: ['1'],
      baseUrl: window.__baseUrl__,
      productList: [],
      questions: { 'one': false, 'two': false, 'three': false, 'four': false, },
      centerDialogVisible: false,
      activeProduct: {},//选择的卡片
      orderDetail: {},//订单详情
      orderId: 0,
      timer: '',
      userInfo: {},
    }
  },
  mounted () {
    this.userInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {}
    this.getRankList()

    // this.getOrderDetail(6)
    this.$bus.$on("doChangeVisible", (newData) => {

      this.doChangeVisible(newData)
    })

  },
  methods: {
    openinvoicedialog () {
      this.timer = new Date().getTime()
      this.daoqiDialogVisible = true
    },
    changeVisible (val) {
      this.daoqiDialogVisible = val
    },
    changeShow (index) {
      this.questions[index] = !this.questions[index]
    },
    doChangeVisible (newData) {
      console.log(newData, 'new')
      this.centerDialogVisible = newData
    },
    getOrderDetail (orderId) {
      orderDetail(orderId).then((d) => {
        if (d.code == 200) {
          this.orderDetail = d.data
        } else {
          this.$message.error(d.msg)
        }
      })
    },
    changechoose (item) {
      // this.activeProduct = { rankId, price, salePrice }
      this.activeProduct = item
    },
    getRankList () {
      getRankList().then((d) => {
        // console.log(d, 'dd')
        if (d.code == 200) {
          this.productList = d.data
          this.activeProduct = d.data[0] || []
        } else {
          this.$message.error(d.msg)
        }
      })

    },
    // openka () {
    //   this.centerDialogVisible = true
    // },
    getImgCode () {
      this.userInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {}
      if (this.userInfo && (!this.userInfo.mobile || this.userInfo.mobile == '')) {
        eventBus.$emit("openBindMobile", true)
      } else {
        let { rankId, price: total, salePrice: realTotal } = this.activeProduct
        let orderparam = {
          rankId,
          total,
          realTotal
        }
        // console.log(orderparam, 'ddd')
        getOrder(orderparam).then((d) => {
          this.centerDialogVisible = true
          this.orderId = d.orderId
        })
      }

    },

  }
}
</script>

<style lang="less" scoped>
p,
div {
  margin: 0;
  padding: 0;
}
img {
  width: 100%;
  height: 100%;
}
.ver {
  writing-mode: vertical-rl;
}
.textright {
  text-align: right;
}
.marginTop {
  margin-top: 76px;
}
.fontcolor {
  // color: #1c3d85;
  // color: #9b0000;
  color: #494949;
  cursor: pointer;
}
.margin8 {
  margin-right: 8px;
}

// @keyframes rotate {
//   from {
//     transform: rotate(0deg);
//   }
//   to {
//     transform: rotate(180deg);
//   }
// }
.rotate {
  transform: rotate(180deg);
}

// div {
//   box-sizing: border-box;
// }
.top {
  margin-bottom: 80px;
}
.contain {
  width: 100%;
  height: 100%;
  min-height: ~"calc(100% + 96px)";
  box-sizing: border-box;
  background: url("/static/products/bg.jpg") 0 0 repeat;
  background-size: cover;
  // padding-top: 86px;
  font-family: "FangZheng-FanTi-Kaiti";

  .deslist {
    margin: 0 auto 8px;
    width: 1012px;
    height: 197px;
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    justify-content: space-between;

    .desitem {
      width: 332px;
      height: 197px;
      background: #ebeef5;
      border-radius: 10px;
      // padding: 19px 14px 19px 19px;
      display: flex;
      align-items: center;

      // word-wrap: break-word;
      p {
        width: 100%;
        font-size: 18px;
        font-family: "FangZheng-FanTi-Kaiti";
        font-weight: 600;
        color: #cc9933;
        span {
          font-size: 32px;
          // color: #1a4d9c;
          color: #9b0000;
        }
      }
    }
    .padone {
      padding-left: 18px;
    }
    .padtwo {
      // padding: 0 20px;
      padding-left: 20px;
    }
    .padthree {
      // padding: 0 36px;
      padding-left: 36px;
    }
    .padfour {
      // padding: 26px 42px;
      padding-left: 42px;
    }
    .padfive {
      // padding: 0 42px;
      padding-left: 42px;
    }
    .padsix {
      // padding: 0 25px;
      padding-left: 25px;
    }
  }
  .justaround {
    justify-content: center;
  }
  .middle {
    width: 1078px;
    margin: 40px auto 0px;
    .kalist {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: space-between;
    }
    .realpay {
      text-align: center;
      font-size: 28px;
      font-weight: 400;
      color: #a0a0a0;
      font-family: "FangZheng-FanTi";
      span {
        color: #344672;
        // color: #9b0000;
      }
      .applyInvoice {
        font-size: 18.86px;
        color: #a0a0a0;
        cursor: pointer;
      }
    }
    .selbutton {
      width: 100%;
      text-align: center;
      .openbutton {
        //background-color: #3366cc;
        //border-color: #3366cc;
        border-color: #dddbda;
        background-color: #dddbda;
        margin: 30px auto 60px;
        font-family: "FangZheng-FanTi-Kaiti";
        font-weight: 400;
        font-size: 24px;
        // color: #fff;
        color: #9b0000;
        border-radius: 20px;
        padding: 0px 16px 2px;
        cursor: pointer;
      }
    }
  }

  .question {
    width: 100%;
    // height: 300px;
    background-color: #f3f4f7;
    font-family: SimSun, PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica,
      Tahoma, Arial, PingFang SC-Light, Microsoft YaHei;
    font-weight: 600;
    margin-bottom: 50px;
    .quescontain {
      width: 1110px;
      margin: 0 auto;
      padding: 40px 0 200px;
      .queshead {
        font-size: 30px;
        // font-weight: 500;
        // color: #1c3d85;
        // color: #9b0000;
        color: #494949;
        text-align: center;
        line-height: 40px;
      }
      .queslist {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .quesitem {
          width: 531px;
          height: 100%;
          // height: 234px;
          position: relative;
          // background: #dcefff;
          background: #dddbda;
          border-radius: 14px;
          margin-top: 20px;
          padding: 0 26px 0 47px;
          .containhead {
            display: block;
            width: 100%;
            height: 62px;
            font-size: 24px;
            // color: #1c3d85;
            //color: #9b0000;
            color: #494949;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .openicon {
              width: 25px;
              height: 25px;
              cursor: pointer;
              // background-color: #fff;
              border-radius: 50%;
              // background: url("/static/products/sanjiao1.png");
              // animation: rotate 5s infinite linear;
            }
          }
          .anwser {
            padding: 14px 26px 20px 47px;
            display: block;
            // opacity: 0;
            position: absolute;
            border-radius: 14px;
            top: 48px;
            left: 0;
            // z-index: 999;
            width: 531px;
            min-height: 100px;
            // transition: all 0.5s ease-in-out;
            // margin-top: 10px;
            font-size: 20px;
            line-height: 30px;
            // font-weight: 550;
            color: #a0a0a0;
          }
        }
        .buluback {
          // background-color: #dcefff;
          background-color: #dddbda;
        }
        .fffback {
          background-color: #fff;
        }
        .zindexone {
          z-index: 9999;
        }
        .zindextwo {
          z-index: 999;
        }
      }
    }
  }

  .kaitem {
    width: 293px;
    height: 178px;
    background: #ffffff;
    box-shadow: 0px 3px 8px 2px rgba(125, 125, 125, 0.3);
    border-radius: 10px;
    // color: #344672;
    color: #9b0000;
    margin-bottom: 28px;
    cursor: pointer;

    // border: none;
    // display: flex;
    // justify-content: space-between;

    overflow: hidden;

    .katitle {
      padding: 20px 0;
      font-size: 130px;
      font-weight: bold;
      margin-left: -26px;
      // color: #1c3d85;
      color: #9b0000;
    }
    .kayue {
      flex: 1;
      display: flex;
      justify-content: space-between;
    }
    .kastart {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
    }
    .kaend {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    }

    .kacontent {
      font-size: 27px;
      font-weight: bold;
      margin-bottom: 0px;
    }
    .kades {
      font-size: 27px;
      font-weight: bold;
      color: #cc9933;
    }
  }
  .zhezhao {
    position: relative;
  }
  .zhezhao::before {
    content: "";
    display: block;
    position: absolute; /* 设置绝对定位 */
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // background-color: #ebeef5;
    // background-color: #dbe3f5;
    background-color: #d9e1f5;
    opacity: 0.5;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/products/index.vue